export default Object.freeze({
  Excel: 0,
  Csv: 1,
});
